<div class="donate showing" *ngIf="clearedToLoad">
    <app-crowdfund-header
        [showAccountButtons]="false"
        [showCampaignAdminNav]="env.merchantUserRoles?.admin"
    ></app-crowdfund-header>

    <div class="crowdfund-admin-common-padding crowdfund-admin-nav-breadcrumbs">
        <app-nav-breadcrumbs></app-nav-breadcrumbs>
    </div>

    <div class="crowdfund-admin-common-padding">
        <div class="crowdfund-admin-section-title-holder">
            <div class="crowdfund-admin-section-title">
                <span>Participants</span>
            </div>
        </div>

        <div *ngIf="data">
            <div class="crowdfund-admin-common-list-item-holder" *ngFor="let cp of data.campaignParticipants">
                <app-admin-campaign-participant-list-item
                    [campaign]="data.campaign"
                    [campaignParticipant]="cp"
                ></app-admin-campaign-participant-list-item>
            </div>
        </div>
    </div>
</div>
